import {guid} from './utils';
import {ClientUser} from "./user";

export function createMessage(message: string, from: ClientUser, type: MessageTypes, pinned = false): Message {
  return new Message(guid(), message, new Date().getTime(), from, type, pinned);
}

export class Message {
  constructor(readonly id: string, public message: string, public sent: number, readonly from: ClientUser, readonly type: MessageTypes, readonly pinned: boolean) {
  }
}

export enum MessageTypes {
  text = 'text',
  image = 'image'
}

export enum ToType {
  CHAT, USER
}

